import { useSelector } from "react-redux";
import { getCurrentHotspot, getCurrentStep } from "../../redux/selectors";
import { steps } from "../../util/constants";
import { AddHotspot } from "./AddHotspot/AddHotspot";
import { AdjustPlacementButton } from "./AdjustPlacementButton/AdjustPlacementButton";
import { LocationModeBottomPanelContent } from "./LocationModeBottomPanelContent/LocationModeBottomPanelContent";
import { Island } from "../Island/Island";

const states = {
  canAddHotspot: "canAddHotspot",
  canAdjustPlacement: "canAdjustPlacement",
  placing: "placing",
};

const stateToContentMap = {
  canAddHotspot: <AddHotspot />,
  canAdjustPlacement: (
    <>
      <AddHotspot />
      <AdjustPlacementButton />
    </>
  ),
  placing: <LocationModeBottomPanelContent />,
};

export function BottomPanel() {
  const step = useSelector(getCurrentStep);
  const currentHotspot = useSelector(getCurrentHotspot);
  let state;
  if (step === steps.configureLocations) {
    state = states.placing;
  } else if (currentHotspot !== null) {
    state = states.canAdjustPlacement;
  } else {
    state = states.canAddHotspot;
  }
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "transparent",
        width: "100%",
        position: "relative", // to correctly position the HelpButton
        marginBottom: "16px",
      }}
    >
      <Island>{stateToContentMap[state]}</Island>
    </div>
  );
}
